import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';

import { useLocalStorage } from '@/hooks/useLocalStorage';

/**
 * Generic hook for managing DataGrid column visibility with localStorage persistence
 *
 * @param storageKey - Unique key for localStorage (e.g., 'employees-columns')
 * @param defaultVisibility - Default column visibility configuration
 * @returns Column visibility state and handlers
 */
export const useColumnVisibility = (
  storageKey: string | null | undefined,
  defaultVisibility: GridColumnVisibilityModel,
) => {
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useLocalStorage<GridColumnVisibilityModel>(storageKey, defaultVisibility);

  // Handle column visibility toggle for checkboxes
  const handleColumnToggle = (field: string) => () => {
    setColumnVisibilityModel((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return {
    columnVisibilityModel,
    handleColumnToggle,
    setColumnVisibilityModel,
  };
};
